var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83342 5.83329V2.49996C5.83342 2.27895 5.92121 2.06698 6.07749 1.9107C6.23377 1.75442 6.44573 1.66663 6.66675 1.66663H17.5001C17.7211 1.66663 17.9331 1.75442 18.0893 1.9107C18.2456 2.06698 18.3334 2.27895 18.3334 2.49996V13.3333C18.3334 13.5543 18.2456 13.7663 18.0893 13.9225C17.9331 14.0788 17.7211 14.1666 17.5001 14.1666H14.1667V17.4941C14.1667 17.9575 13.7926 18.3333 13.3276 18.3333H2.50592C2.39568 18.3334 2.28651 18.3118 2.18465 18.2696C2.08279 18.2275 1.99024 18.1657 1.91229 18.0878C1.83434 18.0098 1.77254 17.9173 1.7304 17.8154C1.68827 17.7135 1.66664 17.6044 1.66675 17.4941L1.66925 6.67246C1.66925 6.20913 2.04342 5.83329 2.50842 5.83329H5.83342ZM7.50008 5.83329H13.3276C13.7909 5.83329 14.1667 6.20746 14.1667 6.67246V12.5H16.6667V3.33329H7.50008V5.83329ZM3.33591 7.49996L3.33342 16.6666H12.5001V7.49996H3.33591Z",
    fill: "#595D67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.340bf187b2b6119a4b1acefdc24a0599.svg";
export { ForwardRef as ReactComponent };